import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { logError } from '@sequencehq/utils'
import { getApiErrorMessage } from 'Cube/utils/getApiErrorMessage'

export const useDeleteAnrokMapping = () => {
  const { displayNotification } = useNotifications()

  const { mutateAsync: deleteTaxCategoryAnrokMapping } = useMutation(
    dashboardv99990101Client.deleteTaxCategoryAnrokMapping
  )

  return async (taxCategoryId: string) => {
    try {
      await deleteTaxCategoryAnrokMapping(taxCategoryId)

      displayNotification('Anrok tax code mapping removed', {
        type: 'success'
      })
    } catch (error) {
      console.error('Failed to remove Anrok mapping:', error)
      logError(error)

      const backendMessage = getApiErrorMessage(error, '')
      const errorMessage = backendMessage
        ? `Failed to remove Anrok tax code mapping: ${backendMessage}`
        : 'Failed to remove Anrok tax code mapping'

      displayNotification(errorMessage, {
        type: 'error'
      })
      throw error
    }
  }
}
